// import WalletResponse from "@/model/responses/WalletResponse";
import LoaderUtils from "@/utils/BaseUtils/LoaderUtils";
import WalletRequest from "@/model/requests/WalletRequest";
import WalletServices from "@/services/WalletServices";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import StripeWalletServices from "@/services/StripeWalletServices";
import NotificationUtils from "@/utils/BaseUtils/NotificationUtils";
const walletService = new WalletServices();

export const namespaced = true;

export const state = {
  balanceInfo: {},
  recentTransactions: [],
  clientSecret: "",
  paymentIntent: {},
  amount: "",
  paymentStatus: false,
  loading: false,
  walletInfo: {},
  flutterwaveURL: ""
};

export const getters = {
  getBalanceInfo: state => {
    return state.balanceInfo;
  },
  getRecentTransactions: state => {
    return state.recentTransactions;
  },
  getClientSecret: state => {
    return state.clientSecret;
  },
  getPaymentIntent: state => {
    return state.paymentIntent;
  },
  getAmount: state => {
    return state.amount;
  }
};

export const mutations = {
  updatePaymentStatus: (state, payload) => {
    state.paymentStatus = payload;
  },
  updateBalanceInfo: (state, payload) => {
    state.balanceInfo = payload;
  },
  updateRecentTransactions: (state, payload) => {
    state.recentTransactions = payload;
  },
  setClientSecret: (state, payload) => {
    state.clientSecret = payload;
  },
  updatePaymentIntent: (state, payload) => {
    state.paymentIntent = payload;
  },
  updateAmount: (state, payload) => {
    state.amount = payload;
  },
  updateLoading: (state, payload) => {
    state.loading = payload;
  },
  updateWalletInfo: (state, payload) => {
    state.walletInfo = payload;
  },
  updateFlutterwaveURL: (state, payload) => {
    state.flutterwaveURL = payload;
  }
};

export const actions = {
  readBalanceInfo({ commit }, payload = WalletRequest.balanceEnquiry) {
    let successAction = responseData => {
      commit("updateBalanceInfo", responseData);
    };
    return walletService.balanceEnquiry(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  readRecentTransactions(
    { commit },
    payload = WalletRequest.recentTransactions
  ) {
    let successAction = responseData => {
      commit("updateRecentTransactions", responseData.data);
    };
    return walletService.recentTransactions(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  createPaymentIntent({ commit }, payload = WalletRequest.createPaymentIntent) {
    payload.customerId = StoreUtils.rootGetters("auth/getCustomerId");
    commit("updateLoading", true);
    return StripeWalletServices.createPaymentIntent(payload)
      .then(response => {
        commit("updateLoading", false);
        let responseData = response.data;
        if (responseData.status !== null) {
          commit("updatePaymentIntent", responseData);
          commit("updatePaymentStatus", true);
        } else {
        }
      })
      .catch(err => {
        commit("updateLoading", false);
        NotificationUtils.addNotificationSlide(
          err,
          NotificationUtils.type.ERROR
        );
      });
  },

  readWallet({ commit }, payload = WalletRequest.read) {
    let successAction = responseData => {
      commit("updateWalletInfo", responseData.data);
    };
    return walletService.readWallet(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },

  flutterwaveFunding({ commit }, payload = WalletRequest.flutterwaveFunding) {
    commit("updateLoading", true);
    // let successAction = () => {
    //   commit("updateLoading", false);
    // };
    //
    // return walletService.flutterwaveFunding(
    //     payload,
    //     successAction,
    //     LoaderUtils.types.NONE
    // );
    return StripeWalletServices.flutterwaveFunding(payload)
      .then(response => {
        let responseData = response.data;
        // console.log(responseData);
        commit("updateLoading", false);
        commit("updateFlutterwaveURL", responseData.location);
        if (responseData.responseCode === "00") {
          window.location.href = responseData.location;
        }
      })
      .catch(err => {
        commit("updateLoading", false);
        NotificationUtils.addNotificationSlide(
          err,
          NotificationUtils.type.ERROR
        );
      });
  },

  flutterwaveVerify({ commit }, payload = WalletRequest.flutterwaveVerify) {
    // let successAction = () => {};
    commit("updateLoading", true);

    return StripeWalletServices.flutterwaveVerify(payload)
      .then(response => {
        let responseData = response.data;
        // console.log(responseData);
        commit("updateLoading", false);
      })
      .catch(err => {
        commit("updateLoading", false);
        NotificationUtils.addNotificationSlide(
          err,
          NotificationUtils.type.ERROR
        );
      });
  }

  // return walletService.createPaymentIntent(payload).then(response => {
  //   let responseData = response;
  //   if (responseData.status !== null) {
  //     commit("updatePaymentIntent", responseData);
  //     commit("updatePaymentStatus", true);
  //   }
  // });
};
